<template>
  <div class="position-relative">
    <section class="section-profile-cover section-shaped my-0">
      <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
        <span></span>
        <span></span>
      </div>
      <div class="container shape-container d-flex">
        <div class="col px-0">
          <div class="row">
            <div class="col-lg-6">
              <h1 class="display-2 text-white">Artigos</h1>
              <span class="text-white"
                >Alguns artigos de conhecimento feitos por mim sobre diversos
                temas</span
              >
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- índice -->
    <section class="section section-lg pt-lg-0 mt--200">
      <div class="container">
        <div class="row justify-content-center">
          <div class="row row-grid">
            <div class="col-lg-12">
              <card class="border-0" shadow body-classes="py-5">
                <!-- <icon
                    name="ni ni-check-bold"
                    type="primary"
                    rounded
                    class="mb-4"
                  >
                  </icon>
                  <h6 class="text-primary text-uppercase">Nodejs</h6>
                  <p class="description mt-3">
                    A maior parte da minha experiência é em Nodejs, essa
                    ferramenta incrível permite criar APIs para o gerenciamento
                    de sites e sistemas
                  </p> -->
                <div class="blockquote mx-2">
                  <a href="#" @click.prevent="setFilter('node')">
                    <badge tag="a" class="mx-1" type="primary" rounded
                      >NodeJS</badge
                    >
                  </a>
                  <a href="#" @click.prevent="setFilter('web')">
                    <badge tag="a" class="mx-1" type="primary" rounded
                      >WEB</badge
                    >
                  </a>
                  <a href="#" @click.prevent="setFilter('database')">
                    <badge tag="a" class="mx-1" type="primary" rounded
                      >Database</badge
                    >
                  </a>
                  <a href="#" @click.prevent="setFilter('android')">
                    <badge tag="a" class="mx-1" type="primary" rounded
                      >Android</badge
                    >
                  </a>
                  <a href="#" @click.prevent="setFilter('')">
                    <badge tag="a" class="mx-1" type="primary" rounded
                      >Todos</badge
                    >
                  </a>
                </div>
                <!-- <base-button tag="a" href="#" type="primary" class="mt-4">
                    Learn more
                  </base-button> -->
              </card>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- articles -->
    <section id="articles" class="section section-lg pt-lg-0 mt--50">
      <div class="container">
        <div class="row justify-content-center">
          <div class="row row-grid">
            <div class="col-lg-12">
              <card
                v-for="item in filteredArticles"
                :key="item.title"
                :id="item.id"
                class="border-0 mt-5"
                shadow
                hover
                body-classes="py-5"
              >
                <a href="#" @click="navigate(item)">
                  <div class="row justify-content-center">
                    <div class="col-sm-12 col-md-4">
                      <img
                        :class="`img-fluid floating ${item.imageStyle}`"
                        v-lazy="require(`@/assets/images/${item.image}`)"
                      />
                    </div>
                    <div class="col-sm-12 col-md-4 mt-5">
                      <h1>{{ item.title }}</h1>
                      <span>{{ item.description }}</span>
                    </div>
                  </div>
                </a>
              </card>

              <h2 v-if="filteredArticles.length == 0">
                Nenhum artigo encontrado
              </h2>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "blog",
  computed: {
    filteredArticles() {
      if (!this.getFilter) return this.articles;

      return this.articles.filter((item) => item.category == this.getFilter);
    },
    article: {
      get() {
        return this.$store.article;
      },
      set(value) {
        this.$store.article = value;
      },
    },
    ...mapGetters(["getFilter"]),
  },
  data: () => ({
    articles: [
      {
        id: 1,
        category: "web",
        title: "VueJS",
        description:
          "Vue é uma estrutura progressiva para construir interfaces de usuário.",
        image: "vue.jpg",
      },
      {
        id: 2,
        category: "web",
        title: "Vuetify",
        description:
          "Vuetify é uma estrutura de IU completa construída sobre Vue.js.",
        image: "vuetify.png",
        imageStyle: "m-3",
      },
      {
        id: 3,
        category: "database",
        title: "PostgreSQL",
        description:
          "PostgreSQL é um poderoso sistema de banco de dados relacional objeto de código aberto.",
        image: "postgreSQL.png",
        imageStyle: "m-5",
      },
      {
        id: 4,
        category: "node",
        title: "NodeJS",
        description:
          "O NodeJS foi projetado para construir aplicativos de rede escalonáveis.",
        image: "nodejs-resized.png",
        imageStyle: "m-3",
      },
      {
        id: 5,
        category: "node",
        title: "Knex JS",
        description:
          "Knex é um query builder para executar querys de forma simples e fácil com o NodeJS.",
        image: "knex.png",
        imageStyle: "m-3",
      },
    ],
  }),
  methods: {
    setFilter(value) {
      this.$store.commit("setFilter", value);
    },
    navigate(item) {
      if (!item || !item.id) return;

      this.article = item;

      this.$router.push({
        name: "ArticleById",
        params: { id: item.id },
        hash: "#articles",
      });
    },
  },
  mounted() {
    this.article = {};
  },
};
</script>